<template>
  <div :style="{ 'background-image': `url('${ thumbnail }'), url('${ defaultThumbnail }')`}"
       style="background-position: center top; background-repeat: no-repeat; background-size: cover"></div>
</template>

<script>
import defaultThumbnail from '../assets/default-screenshot.png';

export default {
  name: 'Screenshot',
  props: {
    src: {
      type: String,
      default: defaultThumbnail
    }
  },
  data() {
    return {
      thumbnail: this.src,
      defaultThumbnail,
    };
  },
};
</script>
